/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { growlErrors } from '../../../utils/NotificationUtil';
import { searchAsmtTemp } from '../../../services/apps/AssessmentTempServices';
import { createTeamReport } from '../../../services/apps/TeamReportService';
import { validationMessages } from '../../../i18n/common';
import { renderAsyncSelector } from '../../../components/formik-components/FormAsyncSelector';
import { dropDownNormalizer } from '../../../utils/NomalizeUtil';
import { LegacyInputTextComponent } from '../../../components/prime-formik';
import { AccountContext } from '../../../components/AccountContext';
import { NotificationContext } from '../../../components/GrowlNotifications';
import useSubscriptionExpiredRestrictions from '../../../hooks/useSubscriptionExpiredRestrictions';

const i18n = defineMessages({
  namePlaceholder: { id: 'name', defaultMessage: 'Name' },
  choose: { id: 'choose', defaultMessage: 'Choose' },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
  create: { id: 'actions.save', defaultMessage: 'Save' },
});

const NewTeamReportContainer = () => {
  const [loading, setLoading] = useState(false);
  const [assessmentTemplates, setAssessmentTemplates] = useState([]);

  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const history = useHistory();
  const { formatMessage } = useIntl();
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  const getTemplate = async (query) => {
    setLoading(true);

    try {
      const result = await searchAsmtTemp({
        aid: currentAccount,
        query,
      });

      setAssessmentTemplates(result);
    } catch (err) {
      growlErrors(growl, err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTemplate();
  }, []);

  const onCancel = () => {
    history.push(`/accounts/${currentAccount}/team-reports`);
  };

  const searchTemp = (query) => {
    getTemplate(query);
  };

  const handleonSave = async (formValues) => {
    const { teamName, assessmentTemplate } = formValues;
    try {
      const result = await createTeamReport({
        accountId: currentAccount,
        teamName,
        assessmentTemplateId: assessmentTemplate.id,
      });
      const { id } = result.createTeamReport;
      const importURL = `/accounts/${currentAccount}/team-reports/${id}`;

      history.push(importURL);
    } catch (graphqlResponse) {
      growlErrors(growl, graphqlResponse);
    }
  };

  const initialValues = { teamName: '' };
  const validationSchema = Yup.object().shape({
    teamName: Yup.string().required(formatMessage(validationMessages.required)),
  });

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <div className="p-grid">
            <div className="p-col-6">
              <Formik onSubmit={handleonSave} initialValues={initialValues} validationSchema={validationSchema}>
                {({ setFieldValue, isSubmitting }) => {
                  return (
                    <Form>
                      <Panel header={<FormattedMessage id="team_report.new" defaultMessage="New Team Report" />}>
                        <div className="p-grid p-fluid">
                          <div className="p-col-12">
                            <div className="{{if errors.name 'has-error'}}">
                              <label className="field-label" htmlFor="report-name">
                                <FormattedMessage id="team_report.team_name" defaultMessage="Team Name" />
                              </label>
                              <Field
                                id="teamName"
                                type="text"
                                name="teamName"
                                component={LegacyInputTextComponent}
                                placeholder={formatMessage(i18n.namePlaceholder)}
                              />
                            </div>
                          </div>
                          <div className="p-col-12">
                            <label className="field-label" htmlFor="assessmentTemplate">
                              <FormattedMessage id="assessment-template" defaultMessage="Assessment Template" />
                            </label>
                            <Field
                              id="assessmentTemplate"
                              name="assessmentTemplate"
                              component={renderAsyncSelector}
                              data={assessmentTemplates}
                              valueField="id"
                              onSearch={searchTemp}
                              processing={loading}
                              normalize={(data) => dropDownNormalizer(data, 'id')}
                              textField="title"
                              placeholder={`- ${formatMessage(i18n.choose)} -`}
                              setFieldValue={setFieldValue}
                              filter
                            />
                          </div>
                        </div>
                        <div className="p-grid">
                          <div className="p-col-12">
                            <Button
                              type="button"
                              className="p-button-secondary"
                              label={formatMessage(i18n.cancel)}
                              onClick={onCancel}
                            />
                            <Button
                              type="submit"
                              icon={isSubmitting ? 'pi pi-spin pi-spinner' : ''}
                              label={formatMessage(i18n.create)}
                              disabled={subscriptionIsExpired}
                            />
                          </div>
                        </div>
                      </Panel>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewTeamReportContainer;
